<template>
  <ModalFormulario
    :model-value="true"
    titulo="Gerar Arquivo SPED"
    :loading="salvando"
    texto-confirmar="Gerar"
    @update:model-value="emit('fechar')"
    @confirmar="gerar"
  >
    <div class="row g-3">
      <div class="col-md-6">
        <CampoBusca
          id="idFilial"
          label="Filial"
          v-model="form.idFilial"
          :configuracao-busca="configFilial"
          required
        />
      </div>
      <div class="col-md-6">
        <CampoBuscaLista
          id="lstTipoSped"
          label="Tipo de Arquivo"
          v-model="form.lstTipoSped"
          tabela="SpedArquivoGerado"
          required
        />
      </div>
      <div class="col-md-3">
        <CampoInput id="periodoInicio" label="Período Inicial" v-model="form.periodoInicio" type="date" required />
      </div>
      <div class="col-md-3">
        <CampoInput id="periodoFim" label="Período Final" v-model="form.periodoFim" type="date" required />
      </div>
      <div class="col-md-6">
        <CampoBusca
          id="idContabilista"
          label="Contabilista (registro 0100)"
          v-model="form.idContabilista"
          :configuracao-busca="configContabilista"
        />
      </div>
      <div class="col-12">
        <CampoInput id="observacao" label="Observação" v-model="form.observacao" maxlength="500" />
      </div>
    </div>
  </ModalFormulario>
</template>

<script setup>
import { reactive, ref, computed } from 'vue'
import api from '@/services/api'
import { useAuthStore } from '@/stores/auth'
import ModalFormulario from '@/components/base/modal/ModalFormulario.vue'
import CampoInput from '@/components/base/campos/CampoInput.vue'
import CampoBusca from '@/components/base/campos/CampoBusca.vue'
import CampoBuscaLista from '@/components/base/campos/CampoBuscaLista.vue'
import { filialSearch } from '@/search-definitions/filialSearch'
import { criarConfigBuscaContabilista } from '@/search-definitions/contabilistaSearch'

const emit = defineEmits(['fechar', 'gerado', 'show-notification'])

const authStore = useAuthStore()
const salvando = ref(false)

const form = reactive({
  idFilial: null,
  lstTipoSped: '',
  periodoInicio: '',
  periodoFim: '',
  idContabilista: null,
  observacao: ''
})

const configFilial = computed(() => filialSearch)
const configContabilista = computed(() => criarConfigBuscaContabilista())

const gerar = async () => {
  salvando.value = true
  try {
    await api.post('/SpedsArquivos/gerar', {
      ...form,
      idOrganizacao: authStore.organizacaoAtiva
    })
    emit('show-notification', { message: 'Arquivo SPED gerado com sucesso.', type: 'success' })
    emit('gerado')
  } catch (error) {
    const data = error.response?.data
    let msg = 'Erro ao gerar o arquivo SPED.'
    if (typeof data === 'string') msg = data
    else if (data?.message) msg = data.message
    else if (data?.title) msg = data.title
    else if (data?.errors) msg = Object.values(data.errors).flat().join('; ')
    emit('show-notification', { message: msg, type: 'error' })
  } finally {
    salvando.value = false
  }
}
</script>
